import React from "react";
import { TableCellProps as VirtTableCellProps } from "react-virtualized";

export type ColumnWidth = number | "auto";

export type TableCellProps<ROW> = Omit<VirtTableCellProps, "rowData"> & {
  rowData: ROW;
  onRowUpdate?: any;
};

export type TableCellRenderer<ROW> = (props: TableCellProps<ROW>) => React.ReactNode;

export type TableSearchColumn<ROW> = {
  cellRenderer?: TableCellRenderer<ROW>;
  className?: string;
  dataKey: string;
  fitted?: boolean;
  label: React.ReactNode;
  numeric?: boolean;
  headerStyle?: React.CSSProperties;
  style?: React.CSSProperties; // cell style
  innerStyle?: React.CSSProperties; // cell inner wrapper style
  skip?: boolean;
  tooltip?: string;

  vAlign?: "center";

  width?: ColumnWidth; // default = "auto"
  widthProportion?: number; // 1, 2, 3, etc.., default = 1
};

export const tableSearchColumnsDefaults: Partial<TableSearchColumn<any>> = {
  width: "auto",
  widthProportion: 1
};
